import { ReactElement } from 'react';
import { AttentionIcon, AvatarGroup, Tooltip, Typography } from '@weareopenr/component-library';
import styles from './MenuSection.module.scss';
import { NO_CHANNEL_AVAILABILITY_MESSAGE, NO_VENUE_AVAILABILITY_MESSAGE } from './constants';
import { pluralize } from 'src/helpers/pluralize/pluralize';
import { IChannelAvailability } from 'src/types/menu.types';

export interface IMenuSectionMetaProps {
  productCount: number;
  subsectionCount: number;
  channels: IChannelAvailability[];
  isChannelsUnavailable: boolean;
  venueCount?: number;
  isVenuesUnavailable: boolean;
}

const MenuSectionMeta = ({
  productCount,
  subsectionCount,
  channels,
  isChannelsUnavailable,
  venueCount,
  isVenuesUnavailable,
}: IMenuSectionMetaProps): ReactElement => {
  const hasChannels = !!channels.length;

  return (
    <div className={styles['meta-row']}>
      <Typography size="xsmall" className={productCount === 0 ? styles['tomato'] : styles['caviar']}>
        {productCount} {pluralize('Product', productCount)}
      </Typography>
      {subsectionCount > 0 && (
        <>
          <Typography size="xsmall" className={styles['caviar']}>
            •
          </Typography>
          <Typography size="xsmall" className={styles['caviar']}>
            {subsectionCount} Sub-section{subsectionCount === 1 ? '' : 's'}
          </Typography>
        </>
      )}
      {(hasChannels || isChannelsUnavailable) && (
        <>
          <Typography size="xsmall" className={styles['caviar']}>
            •
          </Typography>
          <div className={styles['channels']}>
            <Typography size="xsmall" className={styles['caviar']}>
              Channels -
            </Typography>
            <Tooltip
              text={
                isChannelsUnavailable
                  ? NO_CHANNEL_AVAILABILITY_MESSAGE
                  : channels.map((channel) => channel.name).join(', ')
              }
            >
              <div className={styles['channels-avatars']}>
                {hasChannels && (
                  <AvatarGroup
                    max={3}
                    avatars={channels.map((channel) => ({
                      variant: 'custom',
                      imageUrl: channel.faviconUrl,
                      brand: channel.name,
                      initials: channel.faviconUrl ? undefined : channel.name.slice(0, 2).toUpperCase(),
                    }))}
                  />
                )}
                {isChannelsUnavailable && <AttentionIcon className={styles['tomato']} size="xsmall" />}
              </div>
            </Tooltip>
          </div>
        </>
      )}
      {(venueCount !== undefined || isVenuesUnavailable) && (
        <>
          <Typography size="xsmall" className={styles['caviar']}>
            •
          </Typography>
          <div className={styles['channels']}>
            <Typography size="xsmall" className={styles['caviar']}>
              Venues - {venueCount !== undefined && !isVenuesUnavailable && <strong>{venueCount}</strong>}
            </Typography>
            {isVenuesUnavailable && (
              <Tooltip text={NO_VENUE_AVAILABILITY_MESSAGE}>
                <AttentionIcon className={styles['tomato']} size="xsmall" />
              </Tooltip>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MenuSectionMeta;
